import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when IMS sends reality check popup is shown.
 * @memberOf Playtech.API.events
 * @event reality-check-popup-shown
 * @example Playtech.on('reality-check-popup-shown', () => {
 *     // ...
 * });
 */
/**
 * Event fires when IMS sends reality check popup is closed.
 * @memberOf Playtech.API.events
 * @event reality-check-popup-closed
 * @property status {String}  Whether popup was accepted or declined.
 * @example Playtech.on('reality-check-popup-closed', (status) => {
 *     // ...
 * });
 */

 export const REALITY_CHECK_POPUP_SHOWN = 'reality-check-popup-shown';
 export const REALITY_CHECK_POPUP_CLOSED = 'reality-check-popup-closed';

export const useOnRealityCheckPopup = (eventTarget) => {
    const triggerRealityCheckShownAPIEvent = useCallback(() => {
        const popupShown = new CustomEvent(REALITY_CHECK_POPUP_SHOWN);

        eventTarget.dispatchEvent(popupShown);
    }, [eventTarget]);

    const triggerRealityCheckClosedAPIEvent = useCallback((status) => {
        const popupClosed = new CustomEvent(REALITY_CHECK_POPUP_CLOSED, { detail: status });

        eventTarget.dispatchEvent(popupClosed);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('realityPopup:shown', triggerRealityCheckShownAPIEvent);
        publicEventsAPIService.on('realityPopup:closed', triggerRealityCheckClosedAPIEvent);

        return () => {
            publicEventsAPIService.off('realityPopup:shown', triggerRealityCheckShownAPIEvent);
            publicEventsAPIService.off('realityPopup:closed', triggerRealityCheckClosedAPIEvent);
        };
    }, [triggerRealityCheckClosedAPIEvent, triggerRealityCheckShownAPIEvent]);
};
